<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div>
  <div class="modal-header">
    <h5 class="modal-title" [xdaTranslate]="'SDE_MY_ACCOUNT'"></h5>
  </div>

  <div class="modal-body" tabindex="-1">
    <div class="form-group" match-button-width>
      @if (user) {
        <div>
          <h4>{{ user.first_name }} {{ user.last_name }}</h4>
          <span [textContent]="user.email"></span><br />
          <span [textContent]="user.company"></span>
          <p [textContent]="user.countryName" style="margin-bottom: 32px"></p>
          <p>
            <button
              class="xrx-btn btn-secondary"
              (click)="editAccount()"
              [xdaTranslate]="'SDE_EDIT_ACCOUNT_INFO'"></button>
          </p>
          @if (!user.authType) {
            <p>
              <button
                class="xrx-btn btn-secondary"
                (click)="changePassword()"
                [xdaTranslate]="'SDE_CHANGE_PASSWORD'"></button>
            </p>
          }
          @if (user.isSubscriptionUser && user.accessListRole != 'Owner') {
            <div>
              <p>
                <button
                  class="xrx-btn btn-secondary"
                  (click)="confirmRemove()"
                  [xdaTranslate]="'SDE_REMOVE_ACCESS_SQUADRON'"></button>
              </p>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <div class="modal-footer">
    <div class="cb">
      <button
        type="button"
        class="xrx-btn btn-secondary"
        data-dismiss="modal"
        (click)="activeModal.dismiss()">
        <span class="btn-label" [xdaTranslate]="'SDE_CLOSE'"></span>
      </button>
    </div>
  </div>
</div>
